/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * --- NEW FILE (V1 - Definitive Linting Fix) ---
 * - MISSION: To fix the final `react-refresh/only-export-components`
 * warning by moving the React Context definition to its own dedicated file.
 *
 * - ARCHITECTURE: This file contains only the `createContext` call. It
 * exports the `LoadingContext` object. It does not contain any React
 * components or hooks.
 *
 * - RESULT: This structural change allows both the Provider component and
 * the consumer hook to import the context from a neutral location, finally
 * satisfying the linter's requirement that component files only export
 * components. This resolves the last remaining linting issue.
 */
import { createContext } from 'react';

export const LoadingContext = createContext({
  isLoading: false,
  setIsLoading: () => {},
});
